/** @format */

import TreeTypeEven from './type-evens';
import { $utils } from '@/utils/publicUtils';

export default {
	props: {
		isUseScope: {
			// 是否启用范围
			type: Boolean,
			default: false,
		},
	},
	methods: {
		// 组织类型3的特殊处理
		loadOrgTreeNode3(node, resolve) {
			const params = {};
			this.loadingTree = true;
			params.includeSub = this.hasSubset;
			const getOrgTreeData = TreeTypeEven.orgTypeEven.methods.findTreeDataByOrg;
			if ($utils.isEmpty(node.data) || node.data.id === '0') {
				params.partyId = this.currentOrgIdValue;
				getOrgTreeData({ params })
					.then((data) => {
						this.loadingTree = false;
						const arr = JSON.parse(JSON.stringify(data));
						let treeData;
						if ($utils.isEmpty(node.data)) {
							treeData = arr;
							resolve(this.toTree(treeData));
						} else {
							treeData = this.filterTreeChildren(arr, 'root');
						}
						resolve(this.toTree(treeData));
					})
					.catch(() => {
						this.loadingTree = false;
						resolve([]);
					});
			} else if (node.data.id !== '0') {
				params.orgId = node.data.id;
				getOrgTreeData({ params })
					.then((data) => {
						this.loadingTree = false;
						const arr = JSON.parse(JSON.stringify(data));
						const treeData = this.filterTreeChildren(this.toTree(arr), 'node', node.data.id);
						resolve(treeData);
					})
					.catch(() => {
						this.loadingTree = false;
						resolve([]);
					});
			}
		},
		// 岗位类型3的特殊处理
		loadPosTreeNode3(node, resolve) {
			const params = {};
			this.loadingTree = true;
			params.includeSub = this.hasSubset;
			const getPositionTreeData = TreeTypeEven.positionTypeEven.methods.findTreeDataByPos;
			if ($utils.isEmpty(node.data) || node.data.id === '0') {
				params.partyId = this.currentOrgIdValue;
				getPositionTreeData({ params })
					.then((data) => {
						this.loadingTree = false;
						const arr = JSON.parse(JSON.stringify(data));

						let treeData;
						if ($utils.isEmpty(node.data)) {
							treeData = arr;
							resolve(this.toTree(treeData));
						} else {
							treeData = this.filterTreeChildren(arr, 'root');
						}
						resolve(this.toTree(treeData));
					})
					.catch(() => {
						this.loadingTree = false;
						resolve([]);
					});
			} else if (node.data.id !== '0') {
				params.posId = node.data.id;
				getPositionTreeData({ params })
					.then((data) => {
						this.loadingTree = false;
						const arr = JSON.parse(JSON.stringify(data));
						// const treeData = this.filterTreeChildren(this.toTree(arr), 'node', node.data.id)
						const treeData = arr.filter((a) => a.parentId === node.data.id);
						resolve(treeData);
					})
					.catch(() => {
						this.loadingTree = false;
						resolve([]);
					});
			}
		},

		// 根据渲染的数据范围类型，筛选目标节点
		filterTreeChildren(treeData, treeScope, nodeId) {
			let data = [];
			// 返回设置的范围节点
			if (treeScope === 'root') {
				const currentOrgIds = this.currentOrgIdValue.split(',');
				treeData.forEach((f) => {
					if (currentOrgIds.includes(f.id)) {
						f.leaf = !this.hasSubset;
						data.push(f);
					}
				});
			}
			// 返回点击节点的子节点
			if (treeScope === 'node') {
				const filter = function (datas) {
					datas.find((item) => {
						if (item.children && item.children !== []) {
							if (item.id === nodeId) {
								data = item.children;
								return;
							} else {
								filter(item.children);
							}
						}
					});
				};
				filter(treeData);
			}
			return data;
		},
	},
};
